"use strict";
'use es6'; // These should be removed once we have 100% adoption of UIApplication

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

require("../listeners/focusStylesListener");

var _setupStyledComponents = require("../listeners/setupStyledComponents");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _Functions = require("../core/Functions");

var _ShareButton = _interopRequireDefault(require("../decorators/ShareButton"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _TabIndex = require("../utils/TabIndex");

var _ClickableContext = require("../context/ClickableContext");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  cursor: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

(0, _setupStyledComponents.setupStyledComponents)();

var UIClickable =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UIClickable, _React$Component);

  function UIClickable(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIClickable);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIClickable).call(this, props));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UIClickable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          autoFocus = _this$props.autoFocus,
          buttonRef = _this$props.buttonRef;

      if (autoFocus) {
        if (buttonRef.current) buttonRef.current.focus();
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(evt) {
      var key = evt.key,
          target = evt.target;
      var _this$props2 = this.props,
          buttonRef = _this$props2.buttonRef,
          disabled = _this$props2.disabled,
          onClick = _this$props2.onClick,
          onKeyDown = _this$props2.onKeyDown;
      (0, _Functions.callIfPossible)(onKeyDown, evt);
      if (target !== buttonRef.current) return; // Simulate click on Enter/Spacebar, to emulate button behavior

      if (key === 'Enter' || key === ' ') {
        if (disabled) {
          evt.preventDefault();
          evt.stopPropagation();
          return;
        }

        (0, _Functions.callIfPossible)(onClick, evt);

        if (key === ' ') {
          evt.preventDefault(); // Prevent page from scrolling (#3575)
        }
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(evt) {
      var _this$props3 = this.props,
          disabled = _this$props3.disabled,
          onClick = _this$props3.onClick;

      if (disabled) {
        evt.preventDefault();
        evt.stopPropagation();
        return;
      }

      (0, _Functions.callIfPossible)(onClick, evt);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          buttonRef = _this$props4.buttonRef,
          className = _this$props4.className,
          __cursor = _this$props4.cursor,
          disabled = _this$props4.disabled,
          __onClick = _this$props4.onClick,
          __onKeyDown = _this$props4.onKeyDown,
          tabIndex = _this$props4.tabIndex,
          Tag = _this$props4.tagName,
          rest = (0, _objectWithoutProperties2.default)(_this$props4, ["buttonRef", "className", "cursor", "disabled", "onClick", "onKeyDown", "tabIndex", "tagName"]);
      return _react.default.createElement(Tag, (0, _extends2.default)({}, rest, {
        "aria-disabled": disabled,
        className: (0, _classNames.default)('private-clickable', className),
        onClick: this.handleClick,
        onKeyDown: this.handleKeyDown,
        ref: (0, _Functions.wrapRefObject)(buttonRef),
        tabIndex: (0, _TabIndex.getTabIndex)(disabled, tabIndex, null)
      }));
    }
  }]);
  return UIClickable;
}(_react.default.Component);

UIClickable.displayName = 'UIClickable';
var StyledClickable = (0, _styledComponents.default)(UIClickable).withConfig({
  displayName: "UIClickable__StyledClickable",
  componentId: "sc-1xu00uc-0"
})(_templateObject(), function (_ref) {
  var cursor = _ref.cursor,
      disabled = _ref.disabled;
  return disabled ? 'not-allowed' : cursor;
});

var UIClickableWithProviders =
/*#__PURE__*/
function (_React$Component2) {
  (0, _inherits2.default)(UIClickableWithProviders, _React$Component2);

  function UIClickableWithProviders(props) {
    var _this2;

    (0, _classCallCheck2.default)(this, UIClickableWithProviders);
    _this2 = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIClickableWithProviders).call(this, props));
    _this2.getPortalReporterDetails = _this2.getPortalReporterDetails.bind((0, _assertThisInitialized2.default)(_this2));
    return _this2;
  }

  (0, _createClass2.default)(UIClickableWithProviders, [{
    key: "getPortalReporterDetails",
    value: function getPortalReporterDetails() {
      var buttonRef = this.props.buttonRef;
      var buttonEl = buttonRef.current;
      return {
        componentName: UIClickable.displayName,
        labelText: buttonEl && buttonEl.innerText
      };
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_ClickableContext.ClickableContextProvider, {
        value: (0, _ClickableContext.makePortalReporter)(this.getPortalReporterDetails)
      }, _react.default.createElement(StyledClickable, this.props));
    }
  }]);
  return UIClickableWithProviders;
}(_react.default.Component);

UIClickableWithProviders.propTypes = {
  autoFocus: _react.PropTypes.bool,
  buttonRef: _refObject.default,
  cursor: _react.PropTypes.string,
  disabled: _react.PropTypes.bool,
  tagName: _react.PropTypes.string.isRequired
};
UIClickableWithProviders.defaultProps = {
  cursor: 'pointer',
  role: 'button',
  tagName: 'div'
}; // Expose the inner component for tests

UIClickableWithProviders.CoreComponent = UIClickable;
UIClickableWithProviders.WrappedComponent = UIClickable;
UIClickableWithProviders.displayName = 'UIClickableWithProviders';

var _default = (0, _ShareButton.default)(UIClickableWithProviders);

exports.default = _default;
module.exports = exports.default;